export enum AudienceUsersSelectionType {
    All = 'all',
    Filtered = 'filtered',
    Selected = 'selected',
}
